import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { pathOr } from 'ramda';
import componentBase from '../../../../src/lib/component-base';
import MultiFlightsList from './children/MultiFlightsList/MultiFlightsList';
import BodyHeader from '../../../../shared/components/BodyHeader/BodyHeader';
import { formattedDate } from '../../../../src/lib/date-time-format';
import BannerAd from '../../../../shared/components/BannerAd/BannerAd';
import { MultiFlight as multiFlightAds } from '../../../FlightTracker/components/ads';
import { addMetaCanonical } from '../../../../shared/lib/meta-tags';

@componentBase('FlightTrackerMultiFlightResults')
export default class FlightTrackerMultiFlightResults extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    flights: PropTypes.object,
    destOriginTitle: PropTypes.string,
    historicalFlightStatus: PropTypes.bool,
    location: PropTypes.object,
    match: PropTypes.object,
    params: PropTypes.object,
    pageIndex: PropTypes.number,
    searchUrl: PropTypes.string,
    user: PropTypes.object,
  };

  static defaultProps = {
    flights: null,
    destOriginTitle: null,
    historicalFlightStatus: false,
  };

  componentDidMount() {
    const { params } = this.props.match;
    if (params.carrier) {
      this.context.reportEvent('Airline', params.carrier, null, null, true);
    }
    if (params.departureAirportCode) {
      this.context.reportEvent('Airport', params.departureAirportCode, 'Departing', null, true);
    }
    if (params.arrivalAirportCode) {
      this.context.reportEvent('Airport', params.arrivalAirportCode, 'Arriving', null, true);
    }

    this.context.reportQueryTimeFrame(params.day, params.month, params.year);
  }

  metaTags = () => {
    const {
      title,
      departureAirport,
      arrivalAirport,
    } = pathOr({}, ['flights', 'header'], this.props);

    if (!departureAirport && !arrivalAirport) {
      return null;
    }

    const byRoute = !!departureAirport && !!arrivalAirport;
    const metaTitle = !byRoute ? title : `Flight Status By Route: ${departureAirport.fs} to ${arrivalAirport.fs}`;
    const keywordsAirport = !byRoute && (departureAirport || arrivalAirport);
    const description = !byRoute ? `Check the current status of flights ${departureAirport ? 'departing from' : 'arriving at'} (${keywordsAirport.fs}) ${keywordsAirport.name}` : `Flight Status By Route: ${departureAirport.fs} to ${arrivalAirport.fs}`;
    const keywordsDepArr = !byRoute && departureAirport ? 'departures' : 'arrivals';
    const keywords = keywordsAirport ?
      `${keywordsAirport.fs} ${keywordsDepArr}, ${keywordsAirport.name} ${keywordsDepArr}, ${keywordsAirport.city} ${keywordsDepArr}, ${keywordsAirport.city} airport ${keywordsDepArr}` :
      `flight status, ${departureAirport.fs} to ${arrivalAirport.fs}, route status`;

    const metaWithoutCanonical = {
      title: metaTitle,
      meta: [
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { property: 'og:title', content: metaTitle },
        { property: 'og:description', content: description },
      ],
    };
    return addMetaCanonical(metaWithoutCanonical, this.props.location.pathname);
  }

  removeCodeshares = results => results && ({
    ...results,
    flights: results.flights.filter(f => f && !f.isCodeshare),
  });

  renderResults = () => {
    const {
      destOriginTitle,
      dispatch,
      flights,
      match,
      pageIndex,
      searchUrl,
      user,
    } = this.props;
    const hideCodeshares = user && user.hideCodeshares;
    const results = hideCodeshares ? this.removeCodeshares(flights) : flights;
    const header = results && results.header;
    const date = formattedDate(user, header, 'date', 'dateMDY');
    const subscriptionActive = user && user.subscriptionActive;
    const topAd = (
      <BannerAd
        topAd
        mobileAd={multiFlightAds.topMobile}
        desktopAd={multiFlightAds.top}
        subscriptionActive={subscriptionActive}
      />
    );
    return (
      <div>
        {topAd}
        {header &&
        <BodyHeader
          primary={header.title}
          primaryAlt={header.mobileTitle}
          secondary={date}
          secondaryAlt={date}
        />}
        {header &&
        <MultiFlightsList
          {...results}
          {...destOriginTitle}
          dispatch={dispatch}
          match={match}
          pageIndex={pageIndex}
          searchUrl={searchUrl}
        />}
      </div>
    );
  }

  render() {
    return (
      <div style={{ marginBottom: '99px' }}>
        <Helmet {...this.metaTags()} />
        {this.renderResults()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/MultiFlight/children/FlightTrackerMultiFlightResults/FlightTrackerMultiFlightResults.js